import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ConfirmationService } from 'primeng/api';
import { SolicitudAtestFitoViewModel, ParametrosNuevaSolicitudAtestFitoViewModel } from '../datosbasicos/datosbasicosAtestFito.types';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { AgenteControlService } from '../../../_mantenimiento/registros/agentescontrol/agentecontrol.service';

@Component({
    selector: 'app-tiposolicitudatestfito-list',
    templateUrl: './tiposolicitudAtestFito-list.component.html',
})
/** tiposolicitud-list component*/
export class TipoSolicitudAtestFitoListComponent extends ComponentBase implements OnInit {
    /** tiposolicitud-list ctor */

    listPais: Tc[];
    listComunidad: Tc[];
    listProvincia: Tc[];
    //RDLF MIRAR EL TIPO De OBSERVABLE
    listAgenteControl: Tc[];

    public isCollapsedTipos = false;
    public isCollapsedDatos = false;
    IdProvincia: number | null;
    solicitudAtestFito: SolicitudAtestFitoViewModel;
    campoObligatorio = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private agenteControlService: AgenteControlService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });
        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });

        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
            tipoSolicitudAtestFito: '',
            IdCa: [null, Validators.required],
            IdAc: [null, Validators.required],
            IdProvincia: [null, Validators.required],
            IdPaisDestino: [null, Validators.required],
        });
    }

    onSelectedTipoSolicitudAtestFito() {
        this.resetFormValues();

        switch (this.form.value.tipoSolicitudAtestFito) {
            case 'CA':
                this.form.controls['IdAc'].disable();
                this.removeValidators('IdAc');
                this.campoObligatorio = false;

                break;
            case 'AC':
                this.form.controls['IdAc'].enable();
                this.addValidator('IdAc', Validators.required);
                this.campoObligatorio = true;

                break;

            default:
                break;
        }
    }

    onSelectComunidad() {
        const idCA = this.form.value.IdCa;

        this.globalService.getProvinciasByComunidad(idCA).subscribe(res => {
            this.listProvincia = res;
        });
        this.agenteControlService.getAgenteControlByCa(idCA).subscribe(res => {
            this.listAgenteControl = res;
        });

        this.form.patchValue({
            IdProvincia: null,
            IdAc: null,
        });
    }

    private resetFormValues() {
        this.form.patchValue({
            IdCa: null,
            IdAc: null,
            IdProvincia: null,
            IdPaisDestino: null,
        });

        this.form.controls['IdAc'].enable();

        this.listProvincia = [];
        this.listAgenteControl = [];
    }

    onNext() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.WriteParams();

        this.router.navigate(['/exportacion/atestacion/datosbasicos/create']);
    }

    private WriteParams() {
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito = new ParametrosNuevaSolicitudAtestFitoViewModel();

        switch (this.form.value.tipoSolicitudAtestFito) {
            case 'CA':
                this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdTipoSolicitudAtestFito = 1;
                break;
            case 'AC':
                this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdTipoSolicitudAtestFito = 2;
                break;
        }
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.tipoSolicitudAtestFito = this.form.value.tipoSolicitudAtestFito;
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdCa = this.form.value.IdCa;
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdAc = this.form.value.IdAc;
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdProvincia = this.form.value.IdProvincia;
        this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito.IdPaisDestino = this.form.value.IdPaisDestino;
        //SET de los parametros de la nueva solicitud para guardarlos en el localStorage
        this.solicitudAtestFitoService.setParamsSolicitudAtestFito(this.solicitudAtestFitoService.currentParamNuevaSolicitudAtestFito);
    }

    onBack() {
        this.router.navigate(['/exportacion/atestaciones']);
    }
}
